export const ACCESS_TOKEN = 'ACCESS_TOKEN';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const CLIENT_ID = 'CLIENT_ID';
export const VIEW_IS_LIST = 'viewIsList';
export const LANGUAGE_KEY = 'sv_lng';
export const LIGHT_THEME = 'light_theme';
